import { render, staticRenderFns } from "./LudiFooter.vue?vue&type=template&id=6a91b1f0&scoped=true&"
import script from "./LudiFooter.vue?vue&type=script&lang=js&"
export * from "./LudiFooter.vue?vue&type=script&lang=js&"
import style0 from "./LudiFooter.vue?vue&type=style&index=0&id=6a91b1f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a91b1f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VFooter,VRow})
